const AppointmentViewFilters = {
  default: [
      {
  label: "Department",
  key: "department",
  options: [
    "General Physician",
    "Cardiologist",
    "Dermatologist",
    "Neurologist",
    "Orthopedic Surgeon",
    "Pediatrician",
    "Psychiatrist",
    "Gynecologist",
    "Oncologist",
    "ENT Specialist",
    "Ophthalmologist",
    "Dentist",
    "Radiologist",
    "Anesthesiologist",
    "Gastroenterologist",
    "Nephrologist",
    "Urologist",
    "Endocrinologist",
    "Pulmonologist",
    "Rheumatologist",
    "Hematologist",
    "Plastic Surgeon",
    "General Surgeon",
    "Neurosurgeon",
    "Cosmetologist",
    "Pathologist",
    "Sexologist",
    "Allergist/Immunologist",
    "Diabetologist",
    "Laparoscopic Surgeon",
    "Internal Medicine Specialist",
    "Homeopathic Doctor",
    "Ayurvedic Doctor",
    "Unani Practitioner",
    "Occupational Therapist",
    "Physiotherapist"
  ]
},
      {
  label: "Gender",
  key: "gender",
  options: [
    "Male",
    "Female",
  ]
},


      {
  label: "Appointment Type",
  key: "checkInType",
  options: [
    "Follow-up",
    "General Check-up",
    "Emergency",
  ]
},

  ],

  defaultdoctor: [
      {
  label: "Gender",
  key: "gender",
  options: [
    "Male",
    "Female",
  ]
},


      {
  label: "Appointment Type",
  key: "checkInType",
  options: [
    "Follow-up",
    "General Check-up",
    "Emergency",
  ]
},

  ],

  additional: [
  {
      label: "Date",
      key: "dateCheckedIn",
      operator: "Between",
      inputType: "date-range",
    }
  ]
};

export default AppointmentViewFilters; 